import {base} from '@hb/environments/homebase/environment.base';


export const environment = {
  ...base,
  production: false,
  staging: true,
  configuration: 'homebase-staging',
};
